import account from "./account";
import bots from "./bots";
import createPersistedState from "vuex-persistedstate";
import { FusionProject } from "@/types";

const namespace: FusionProject = "basis";

export const plugins = [
  createPersistedState({
    key: namespace,
    paths: [namespace + ".account"]
  })
];

export default {
  namespaced: true,
  modules: {
    account,
    bots
  }
};
